import React from "react";
import financePrbImg from "../../../Assets/Images/img_2.jpg";
import credit from "../../../Assets/Images/credit_card.png";
import QuickLoan from "../../common/Quick_Loan/Quick_Loan";
import { Banner } from "../../common/Banner/Banner";
import classes from "../Loans.module.css";

export const MortgateLoan = () => {
  return (
    <div className="row g-0 bg-gray">
      <div className="col-sm-12 col-md-12 col-lg-12">
        <Banner />
      </div>
      <div className={`container col-sm-12 col-md-12 col-lg-12 py-5 ${classes.container_width}`}>
        <h2 className="text-center fw-bold text_orange">Mortgage Loan</h2>
        <div className="row g-0 py-4">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <div className={`${classes.criteria}`}>
              <div className="row">
                <div className="col-12 col-sm-12 col-md-12 col-lg-6 px-4">
                  <h5 className="fw-bold mb-4 text_orange">
                    The eligibility criteria for Mortgage loans
                  </h5>
                  <ul className={classes.loan_criteria}>
                    <li>
                      <span>
                        <strong>Nationality:</strong> The applicant should be an
                        Indian citizen.
                      </span>
                    </li>
                    <li>
                      <span>
                        <strong>Age:</strong>The minimum age requirement is 21 years, and the maximum age limit is 65 years for salaried individuals and 70 years for self-employed individuals.
                      </span>
                    </li>

                    <li>
                      <span>
                        <strong>Minimum Income:</strong>For salaried individuals, the minimum monthly income should be Rs. 15,000, and for self-employed individuals, it should be Rs. 12,000.
                      </span>
                    </li>

                    <li>
                      <span>
                        <strong>CIBIL Score:</strong> Your CIBIL score should be
                        750 or higher.
                      </span>
                    </li>
                    <li>
                      <span>
                        <strong> Co-applicant:</strong> If applicable, the co-applicant must be a family member.
                      </span>
                    </li>
                  </ul>
                </div>
                <div className="col-12 col-sm-12 col-md-12 col-lg-6 text-end">
                  <img src={financePrbImg} className={classes.img_width1} />
                </div>
              </div>
              <div className="pt-3 ps-5">
                <div>
                  <h5 className="text_orange">
                  These criteria determine the eligibility for housing loans for individuals.
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row g-0 py-4">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <div className={`row ${classes.criteria}`}>
              <div className="px-4 col-12 col-sm-12 col-md-12 col-lg-6 text-start">
                <img src={credit} className={classes.img_width2}/>
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-6 mt-4 mt-lg-0">
                <h5 className="fw-bold mb-4 text_orange">
                  Please ensure you have the
                  following documents:
                </h5>
                <ul className={classes.loan_criteria}>
                  <li>
                    <span>
                      <strong> KYC documents (Choose one):</strong> Aadhar card,
                      Voter's ID, Passport, PAN card, Office ID, Any OVD proof.
                    </span>
                  </li>

                  <span>
                    <strong className="text_orange">Income proof (SALARIED):</strong>
                    <ul>
                      <li>3 Months Salary Slip</li>
                      <li>6 Months A/C Statement</li>
                      <li>Form 16 (Past 2 years)</li>
                    </ul>
                  </span>

                  <span>
                    <strong className="text_orange">Income proof (BUSINESS):</strong>
                    <ul>
                      <li>2 years ITR</li>
                      <li>Shop Act License</li>
                      <li>12 Months A/C Statement</li>
                    </ul>
                  </span>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-sm-12 col-md-12 col-lg-12">
        <QuickLoan pageHeading="Car" />
      </div>
    </div>
  );
};
